<template>
  <div class='xy-content-module'>
    <div class='xy-content-body'>
      <div class="changeAll" >
        <div class="chang-school" @click="showSchool">
          <span>{{schoolName ? schoolName:''}}</span>
          <img src="./img/down.png" alt="" >
        </div>
        <div class="chang-grade" @click="showGrade">
          <span>{{gradeName ? gradeName: ''}}</span>
          <img src="./img/down.png" alt="" >
        </div>
        <!-- <div class="chang-class" @click="showClass">
          <span>{{className ? className : ''}}</span>
          <img src="./img/down.png" alt=""  v-show="className">
        </div> -->
      </div>
      <van-popup v-model="isShowschool" position="bottom" :style="{ height: '50%' }" >
        <div style="text-align: center;" v-for="(item,index) in layerList" :key="index" @click="changeSchool(item,'checked')">
          <div style="font-size:18Px;padding:18px">{{item.label}}</div>
        </div>
      </van-popup>
      <van-popup v-model="isShowgrade" position="bottom" :style="{ height: '50%' }" @click-overlay="onGrade">
        <div style="text-align: center;" v-for="(item,index) in layerListGrade" :key="index" @click="changeGrade(item,'checked')">
          <div style="font-size:18Px;padding:18px">{{item.label}}</div>
        </div>
      </van-popup>
      <!-- <van-popup v-model="isShowclass" position="bottom" :style="{ height: '50%' }" >
        <div style="text-align: center;" v-for="(item,index) in layerListClass" :key="index" @click="changeClass(item)">
          <div style="font-size:18Px;padding:18px">{{item.label ? item.label:'没有班级可选' }}</div>
        </div>  
      </van-popup> -->
      <!-- <van-search v-model="value" shape="round" placeholder="请输入活动名称" /> -->
      <div class="search-all">
        <van-form action=""  class="search">
        <van-search
            v-model="searchTheme"
            placeholder="请输入活动名称"
            @search="onSearch"
            @cancel="onCancel"
            shape="round"
            left-icon="searchImg"
        >
            <div slot="left-icon" class="searchImg">
              <img :src="searchImg" alt="">
            </div>
        </van-search>
        </van-form>
      </div>
      <div class="assessView null-data" v-if="list.length === 0 && isLoad">
        <img src="@/assets/common/moblie-no-data.png" />
        <div>该搜索条件下没有结果。</div>
      </div>
      <div v-else class="MyActivityEvaluation">
        <van-pull-refresh v-model="isLoading" class="visitlists-refresh" @refresh="onRefresh">
          <!-- 释放提示 -->
          <template #pulling>
            <span style="font-size:14Px">下拉即可刷新...</span>
          </template>
          <!-- 下拉提示 -->
          <template #loosing>
            <span style="font-size:14Px">释放即可刷新...</span>
          </template>
           <van-list
            class="refreshWrap"
            v-model="isRefresh"
            :finished="finished"
            finished-text="没有更多了"
            loading-text=" "
            @load="onLoad"
            >
            <ul>
                <li v-for="(item,index) in list" :key="index">
                    <div class="left-all">
                        <div class="left-all-text">
                            <p>{{item.ActivityCourseProjectName}}</p>
                            <span>{{item.ActivityCourseTypeName}}</span>
                        </div>
                        <span style="margin-right:13px">活动时间</span>
                        <span class="left-all-time">{{xy.moment(item.ActivityCourseStartTime).format('YYYY-MM-DD HH:mm')}}
                          至
                        </span>
                        <span class="left-all-time">{{xy.moment(item.ActivityCourseEndTime).format('YYYY-MM-DD HH:mm')}}</span>
                    </div>
                    <div class="right-all">
                        <div class="info-btn" @click="enterDetal(item)">查看详情</div>
                    </div>
                </li>
            </ul>
            </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
  export default {
    name: 'MyActivityEvaluation',
    data () {
      return {
        layerList:[
          {
            'label': '所有学年',
            'value': 0,
            'children': [{
              'value': 0,
              'label': '所有学期',
              'children': []
            }]
          }
        ],
        layerListGrade:[],
        layerListClass:[],
        schoolName:'',
        gradeName:'',
        className:'',
        schoolId:'',
        gradeId:'',
        classId:'',

        show:false,
        isShowschool:false,
        isShowgrade:false,
        // isShowclass:false,

        pageIndex: 1,
        PageSize: 15,
        total: 0, //总共的数据条数
        isLoading: false, //下拉刷新状态
        isRefresh: false, // 是否加载中
        finished: false, // 加载是否完成
        searchTheme:'',
        svalue:'',
        list:[],
        isLoad: false,
        onloaded:false,
        searchImg: require('./img/search.png'),
        oldSchoolData:[]
      }
    },
    created () {
        Toast.setDefaultOptions('loading', { duration: 0 })
        //this.GetUserRangeClassPermission()
    },
    mounted () {},
    methods :{
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      unloading() {
        Toast.clear()
      },
      fail(a) {
        Toast.fail({
          message: a,
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      showSchool(){
        this.isShowschool = true
        this.isShowgrade = false
        // this.isShowclass = false
      },
      showGrade(){
        this.isShowschool = false
        this.isShowgrade = true
        // this.isShowclass = false
      },
      //获取学年学期
      async GetUserRangeClassPermission() {
        let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/GetSessionNodeList`)
        if (res.success) {
          this.layerList = this.layerList.concat(res.data)
          let index = this.layerList.map(function (item) {
            return item.IsCurrent
          }).indexOf(true)
          if (index !== -1) {
            let index1 = this.layerList[index].children.map(function (item) {
              return item.IsCurrent
            }).indexOf(true)
            if (index1 !== -1) {
              this.changeSchool(this.layerList[index])
              this.changeGrade(this.layerList[index].children[index1])
            } else {
              this.changeSchool(this.layerList[0])
              this.changeGrade(this.layerList[0].children[0])
            }
          } else {
            for (let i = 0; i < this.layerList.length; i++) {
              if (this.layerList[i].children.length > 0) {
               // this.changeSchool(this.layerList[index])
                this.changeSchool(this.layerList[i])
                this.changeGrade(this.layerList[i].children[0])
                break
              }
            }
          }
        } else {
          this.fail(res.msg)
        }
      },
      //选择校区
      changeSchool(item,ischeck){
        this.schoolName = item.label
        this.schoolId = item.value
        this.isShowschool = false
        this.layerListGrade = item.children
        if(ischeck === 'checked'){
          this.isShowgrade = true
        }
      },
      //选择年级
      changeGrade(item,ischeck){
        this.gradeName = item.label
        this.gradeId = item.value
        this.isShowgrade = false
        this.layerListClass = item.children
        //默认选择第一个
        if(ischeck === 'checked'){
          this.isShowclass = true
        }
        //this.getList()
        this.onloaded = true;
        this.pageIndex = 1;
        this.isLoading = false;
        this.list = []
        this.finished = false;
        this.onLoadlist()
        this.oldSchoolData = {
          sName:this.schoolName,
          sId:this.schoolId,
          sList:this.layerList,
          gName:this.gradeName,
          gId:this.gradeId,
          gList:this.layerListGrade
        }
      },
      onGrade(){
        this.schoolName = this.oldSchoolData.sName
        this.schoolId = this.oldSchoolData.sId
        this.layerList = this.oldSchoolData.sList
        this.gradeName = this.oldSchoolData.gName
        this.gradeId = this.oldSchoolData.gId
        this.layerListGrade = this.oldSchoolData.gList
      },
     //获取接口数据
       onLoad(){
        console.log("onloaded",this.onloaded)
        if (!this.onloaded){
          this.GetUserRangeClassPermission()
        }else{
          this.onLoadlist()
        }
      },
      //获取接口数据
      async onLoadlist(){
          await this.getList();
          // 加载状态结束
          this.isRefresh = false;
          this.pageIndex++;   
      },
      //下拉加载
      onRefresh() {
         this.pageIndex = 1;
          this.isLoading = false;
          this.list = []
          this.finished = false;
          this.onLoadlist()
      },
      async getList() {
        this.loading()
        let params = {
          PageIndex:  this.pageIndex,
          PageSize: this.PageSize,
          AcademicYearID: this.schoolId,
          AcademicSessionID: this.gradeId,
          SearchText: this.searchTheme
        }
        let res = await this.xyapi.get(
         `${this.xyMApi}/eva/api/ActivityCourseProjectPad/GetStudentProjectByPage`,params
        )
        this.unloading();
        if (res !== undefined && res.success) {
          // this.xy.unloading();
          // 将新数据与老数据进行合并
          if (res.data === null) {
            this.finished = true;
            return;
          }
         // this.list = this.list.concat(res.data.data?res.data.data:[])
          
          this.list = this.list.concat(res.data.data?res.data.data:[])
          this.total = res.data.totalRecords; //后端传的总条数
          this.isLoad = true
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.list === null || this.list.length === 0 || this.list.length >= this.total)
          {
            this.finished = true
            this.unloading()
            return
          }
        }else{
            this.xy.msgError(res.msg)
            this.finished = true
            }
      },
      //进入详情
      enterDetal(item) {
          this.$router.push({
            path: "/ipad/MyActivityDetails",
            query: {
              ActivityCourseProjectID : item.ActivityCourseProjectID,
              ActivityCourseProjectName: item.ActivityCourseProjectName
            }
        })
      },
      //搜索
      onSearch(val) {
        this.searchTheme = val
        this.pageIndex = 1;
        this.isLoading = false;
        this.list = []
        this.finished = false;
        this.onLoadlist()
        },
      onCancel(){}
    }
  }
</script>
<style lang='less' scoped>
/deep/ .van-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .van-list__finished-text{
    font-size: 14Px;
}
/deep/ .van-search{
    padding: 0;
}
/deep/ .van-search__content--round{
    height: 33px;
}
/deep/ .van-field__control{
    font-size: 14Px;
}
/deep/ .van-icon-clear{
    font-size: 16Px;
}
.xy-content-module{
    position: absolute;
    top: 44px;
    bottom: 10px;
    left: 0;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
}
.search-all{
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
    background: #fff;
    .search{
        width: 95%;
        //background: #f1f1f1;
        border-radius: 40px;
        position: relative;
        input{
            width: 100%;
            height: 100%;
            border: none;
            outline: none; 
            background: #f1f1f1;
            border-radius: 40px;
            text-indent:46px;
            font-size: 18Px;
        }
        img{
            position: absolute;
            width: 24px;
            height: 24px;
            top:22px;
            left:12px;
        }
    }
    .searchImg {
      width: 16px;
      height: 16px;
      position: relative;
      img {
        width: 16px;
        height: 16px;
        left: 0;
        top: 0;
      }
    }
}

.changeAll{
  height: 44px;
  width: 100%;
  font-size: 15Px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #fff;
  div{
    padding:10px;
    flex: 1;
    text-align: center;
    img{
      width:10px;
      height:6px;
      margin-left:5px;
    }
  }
}
.MyActivityEvaluation{
    width: 100%;
    height: auto;
    background: #f5f5f5;
    ul{
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 14px;
        padding-bottom: 20px;
        li{
            width: 96%;
            height: auto;
            background: #fff;
            margin: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px;
            .left-all{
                // width: 84%;
                .left-all-text{
                    display: flex;
                    align-items: flex-start;
                    p{
                        font-size: 18Px;
                        font-weight: bold;
                        word-wrap:break-word;
                        word-break: break-all;
                        display: inline-block;
                        max-width: 690px;
                        line-height: 32px;
                    }
                    span{
                        font-size: 12Px;
                        color: #1677FF;
                        display: inline-block;
                        background: #edf5ff;
                        border: 1px solid #97c3ff;
                        border-radius: 20px;
                        text-align: center;
                        line-height: 20px;
                        margin-top: 3px;
                        margin-left: 10px;
                        padding: 1px 9px;
                        // width: 86px;
                    }
                }
                span{
                    font-size: 16Px;
                    color: rgba(26,26,26,0.42);
                }
            }
        }
    }
}
  .info-btn {
    width: 96px;
    height: 32px;
    background: #1677ff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 14Px;
  }
.assessView {
  width: 100%;
  height: 670px;
}
.null-data {
  margin-top: 100px;
  text-align: center;
  div {
    // prettier-ignore
    font-size:18Px;
  }
}
</style>
